import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { TrackingService } from 'service/tracking/trackingService';

const CustomError = (): React.ReactNode => {
  const router = useRouter();

  useEffect(() => {
    router.push(`/${router.locale}/500`);
    TrackingService.contentGroups({ cg1: 'error page' });
  });
  return <div />;
};

export default CustomError;
